import { VolumetricFlowCalculatorInput } from 'src/modules/user-input/calcVolumetricFlow/types.ts';

export const cloneInput = (input: VolumetricFlowCalculatorInput): VolumetricFlowCalculatorInput => ({
    v100: input.v100,
    v100_u: input.v100_u,
    dpmv: input.dpmv,
    dpmv_u: input.dpmv_u,
    maxDp: input.maxDp,
    maxDp_u: input.maxDp_u,
    mass: input.mass,
    mass_u: input.mass_u,
    inlet: input.inlet,
    inlet_u: input.inlet_u,
    outlet: input.outlet,
    outlet_u: input.outlet_u,
    kvs: input.kvs,
    kvs_u: input.kvs_u,
});
